<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showCity") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <div class="row">
        <!-- Start:: City Info -->
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.city_name_ar')"
          v-model.trim="data.name_ar"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.city_name_en')"
          v-model.trim="data.name_en"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.created_at')"
          v-model.trim="data.created_at"
          disabled
        />

        <!-- Start:: Status Switch Input -->
        <div class="input_wrapper switch_wrapper my-5 col-6">
          <v-switch
            color="green"
            :label="
              data.is_active
                ? $t('PLACEHOLDERS.active')
                : $t('PLACEHOLDERS.notActive')
            "
            v-model="data.is_active"
            hide-details
            disabled
          ></v-switch>
        </div>
        <!-- End:: Status Switch Input -->
      </div>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ShowCity",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        name_ar: null,
        name_en: null,
        is_active: null,
        created_at: null,
      },
      // End:: Data Collection To Send

      // Start:: Map Data
      mapCenter: { lat: 24.7136, lng: 46.6753 }, // Riyadh coordinates
      cityPoints: [],
      polygonOptions: {
        strokeColor: "#FF6B35",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF6B35",
        fillOpacity: 0.35,
        editable: false,
      },
      // End:: Map Data
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // Start:: Show Data
    async showCity() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `cities/${this.$route.params?.id}`,
        });

        const cityData = res.data.data?.City;
        this.data.name_ar = cityData.name_ar;
        this.data.name_en = cityData.name_en;
        this.data.is_active = cityData.is_active;
        this.data.created_at = cityData.created_at;

        // Load city points if available
        // if (cityData.points && cityData.points.length > 0) {
        //   this.cityPoints = cityData.points.map(point => ({
        //     lat: parseFloat(point.lat),
        //     lng: parseFloat(point.lng)
        //   }));
        //   if (this.cityPoints.length > 0) {
        //     const avgLat = this.cityPoints.reduce((sum, point) => sum + point.lat, 0) / this.cityPoints.length;
        //     const avgLng = this.cityPoints.reduce((sum, point) => sum + point.lng, 0) / this.cityPoints.length;
        //     this.mapCenter = { lat: avgLat, lng: avgLng };
        //   }
        // }
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },
    // End:: Show Data
  },

  created() {
    this.showCity();
  },
};
</script>

<style lang="scss" scoped>
.map_section_wrapper {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;

  h5 {
    color: #333;
    margin-bottom: 10px;
  }

  .map_container {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .points_info {
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 6px;

    span {
      font-weight: 500;
      color: #495057;
    }
  }
}
</style>
